<template>
  <div>
    <div class="card" v-if="loading">
      <div class="card-body">
        <div class="text-center">
          <b-spinner class="ms-2" variant="primary"></b-spinner>
        </div>
      </div>
    </div>

    <div class="filtro-component" v-if="!loading">
      <b-card>
        <div class="row cursor-pointer" id="header-filtro" @click="filtroExpandido = !filtroExpandido">
          <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center">
            <h4 class="font-size-16 mb-0 text-uppercase" style="font-weight: 600;">Filtro de  Clientes Rurais</h4>
          </div>

          <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end order-1 order-md-2 mb-2 mb-md-0">
            <div class="d-flex">
              <b-button variant="success" class="me-2" @click="redirectToCadastroEdicao">
                <i class="fa fa-solid fa-plus me-2"></i>
                <span>Novo Cliente</span>
              </b-button>
              <div>
                <i :class="filtroExpandido ? 'mdi mdi-filter' : 'mdi mdi-filter-outline'" class="icone-accordion"></i>
              </div>
            </div>
          </div>
        </div>

      <b-collapse v-model="filtroExpandido" class="mt-3">
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Cooperado">
              <multiselect
                label="name"
                track-by="name"
                select-label=""
                :taggable="false"
                :max-height="200"
                :allowEmpty="false"
                placeholder="Selecione"
                :options="cooperadoLkp"
                v-model="selecaoCooperado"
                @input="carregarClienteRural"
              >
                <span slot="noOptions">Nenhum Cooperado disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Cliente Rural">
              <multiselect
                label="name"
                track-by="name"
                select-label=""
                :max-height="200"
                placeholder="Selecione"
                :options="clienteRuralLkp"
                v-model="selecaoClienteRural"
                :loading="loadingClienteRural"
                invalid-feedback="Campo obrigatório"
              >
                <span slot="noOptions">Nenhum Cliente Rural disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label="CPF / CNPJ">
              <multiselect
                  label="cpfCnpj"
                  :max-height="200"
                  track-by="cpfCnpj"
                  placeholder="Selecione"
                  v-model="selecaoCpfCnpj"
                  v-mask="'###.###.###-##'"
                  :options="filteredOptions"
                  :custom-label="formatCpfCnpj"
                  @search-change="updateSearch"
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Mês Aniversário">
              <multiselect
                v-model="mesAno"
                :options="mes"
                label="label"
                track-by="value"
                placeholder="Selecione o mês"
              ></multiselect>
            </b-form-group>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col-md-3">
            <b-form-group class="mb-3" label="Email">
              <b-form-input v-model.trim="email" type="text" />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label="Municipio - UF">
              <multiselect
                label="name"
                track-by="name"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                placeholder="Selecione"
                v-model="selecaoMunicipio"
                :options="selecaoMunicipioLkp"
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label="Projeto Unicampo">
              <multiselect
                label="name"
                track-by="name"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                placeholder="Selecione"
                v-model="selecaoProjeto"
                :options="selecaoProjetoLkp"
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label="Safra">
              <multiselect
                v-model="selecaoSafra"
                :options="selecaoSafraLkp"
                placeholder="Selecione"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                label="name"
                track-by="name"
              />
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div
            class="col-12 d-flex justify-content-between align-items-center"
          >
            <div class="d-flex">
              <b-button
                class="me-2"
                @click="limparFormulario"
              >
                <i class="mdi mdi-broom align-middle me-1"></i>
                Limpar
              </b-button>
              <b-button variant="primary" class="me-2" @click="emitirFiltro" :disabled="disabledFiltro">
                <i class="mdi mdi-filter-outline align-middle me-1" ></i> Filtrar
                <b-spinner
                  variant="secondary"
                  small
                  class="ms-2"
                  v-if="disabledFiltro"
                ></b-spinner>
              </b-button>
            </div>
          </div>
        </div>
        </b-collapse>
    </b-card>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";


const MESES_DO_ANO = [
  { value: 1, label: "Janeiro" },
  { value: 2, label: "Fevereiro" },
  { value: 3, label: "Março" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Maio" },
  { value: 6, label: "Junho" },
  { value: 7, label: "Julho" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Setembro" },
  { value: 10, label: "Outubro" },
  { value: 11, label: "Novembro" },
  { value: 12, label: "Dezembro" }
];

export default {
  name: "Filtro",
  mixins: [clienteRuralMixin],
  props: {
    redirectToCadastroEdicao: Function
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      loading: true,
      mes: MESES_DO_ANO,
      email: "",
      mesAno: null,
      cdPessoa: "",
      searchQuery: "",
      cooperadoLkp: [],
      selecaoSafra: null,
      clienteRuralLkp: [],
      selecaoSafraLkp: [],
      selecaoProjeto: null,
      selecaoCpfCnpj: null,
      selecaoProjetoLkp: [],
      disabledFiltro: false,
      filtroExpandido: true,
      selecaoMunicipio: null,
      selecaoCooperado: null,
      selecaoMunicipioLkp: [],
      selecaoClienteRural: null,
      loadingClienteRural: false,
    };
  },
  async mounted() {
    await this.buscarDados();
    if(this.$store.state.filtroClienteRuralAstec){
      await this.verificarFiltro(this.$store.state.filtroClienteRuralAstec)
    } else {
      this.emitirFiltro();
    }
  },

  computed: {
    filteredOptions() {
      if (!this.searchQuery) return this.clienteRuralLkp;
      const normalizedSearch = this.normalizeCpfCnpj(this.searchQuery);

      return this.clienteRuralLkp.filter(option => {
        const normalizedOption = this.normalizeCpfCnpj(option.cpfCnpj);
        return normalizedOption.includes(normalizedSearch);
      });
    }
  },


  methods: {
    async buscarDados() {
      await this.buscarLkpSafra();
      await this.getNomeRazaoUsuario();
      await this.buscarMunicipioUf();
      await this.buscarLkpProjeto();
      await this.buscarLkpCooperado();
      await this.verificarCooperado();
      await this.carregarClienteRural();
      this.loading = false;
    },

    async carregarClienteRural() {
      if (this.selecaoCooperado) {
        this.clienteRuralLkp = [];
        this.selecaoClienteRural = null;
        this.loadingClienteRural = true;
        try {
          const response = await this.$http.get("/api/astec/getLkpClienteRuralProjetos/" + this.selecaoCooperado.value);
          this.clienteRuralLkp = response.data.map(cliente => {
            return {
              name: cliente.DISPLAY,
              value: cliente.ID,
              cpfCnpj: cliente.NRCPFCNPJ,
            };
          });
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        this.loadingClienteRural = false;
      }
    },

    async verificarFiltro(filtro) {
      this.selecaoCooperado = this.cooperadoLkp.find(
        (el) => el.value == filtro.cdCooperado
      );
      await this.carregarClienteRural();
      this.selecaoClienteRural = this.clienteRuralLkp.find(
        (el) => el.value == filtro.sqCliente
      );
      this.selecaoCpfCnpj = this.clienteRuralLkp.find(
        (el) => el.value == filtro.sqCliente
      )
      this.mesAno = this.mes.find((el) => el.value == filtro.mes_aniversario) || "";
      this.email = filtro.e_mail || "";
      this.selecaoMunicipio = this.selecaoMunicipioLkp.find(
        (el) => el.value == filtro.sq_regiao
      );
      this.selecaoProjeto = this.selecaoProjetoLkp.find(
        (el) => el.value == filtro.cd_projeto
      );
      this.selecaoSafra = this.selecaoSafraLkp.find(
        (el) => el.name == filtro.safra
      );

      this.emitirFiltro();
    },

    async verificarCooperado() {
      if(this.cooperadoLkp.length > 0) {
        this.selecaoCooperado = this.cooperadoLkp[0];
        return;
      }
    },

    FiltrarClientesRurais() {
      const dados = {
        cdCooperado: this.selecaoCooperado ? this.selecaoCooperado.value : null,
        sqCliente: this.selecaoClienteRural?.value || this.selecaoCpfCnpj?.value || null,
        mes_aniversario: this.mesAno ? this.mesAno.value : "",
        e_mail: this.email ? this.email.trim() : "",
        sq_regiao: this.selecaoMunicipio ? this.selecaoMunicipio.value : null,
        cd_projeto: this.selecaoProjeto ? this.selecaoProjeto.value : null,
        safra: this.selecaoSafra ? this.selecaoSafra.name : null
      };
      return dados;
    },

    emitirFiltro() {
      const filtro = this.FiltrarClientesRurais();
      this.disabledFiltro = true;
      this.$store.commit("PARAMETROS_FILTRO_CLIENTE_RURAL_ASTEC", filtro);
      this.$emit("clientesRuraisFiltrados", filtro, () => {
          this.disabledFiltro = false;
          this.filtroExpandido = true;
        });
    },

    limparFormulario() {
      this.email = "";
      this.mesAno = "";
      this.emitirFiltro();
      this.selecaoSafra = null;
      this.selecaoProjeto = null;
      this.selecaoCpfCnpj = null;
      this.selecaoMunicipio = null;
      this.selecaoClienteRural = null;
      this.$store.commit("PARAMETROS_FILTRO_CLIENTE_RURAL_ASTEC", null);
    },

    formatCpfCnpj(option) {
      return option.cpfCnpj;
    },

    normalizeCpfCnpj(value) {
      if (!value) return "";
      return value.replace(/\D/g, "");
    },

    updateSearch(query) {
      this.searchQuery = query;
    },
  },
};
</script>

<style scoped>
  .icone-accordion{
    font-size: 24px;
  }
</style>
